import Axios from 'axios';
import { omit as _omit } from 'lodash';

const axios = Axios.create({ baseURL: process.env.VUE_APP_API_URL });

export function startClock() {
  return Promise.resolve(new Date().getTime());
}

export function fetchQuiz(gameId) {
  return new Promise((resolve, reject) => {
    if (process.env.NODE_ENV !== 'production') {
      return import('../../dev/api.json').then(quiz => resolve(quiz));
    } else {
      axios
        .get(`/game-sessions/${gameId}`)
        .then(response => resolve(response.data))
        .catch(reject);
    }
  });
}

export function mapQuiz(state, quiz) {
  state.questionsPerRound = quiz.rounds;
  state.game.players = quiz.players.map((player, id) => {
    return { id, score: 60, tookTurn: false, tookFirstTurn: false };
  });
  Object.assign(state, _omit(quiz, ['rounds']));
  return state;
}
